"use strict";
// 语言码：http://nodeapi.webdev.com/wuji_fast?_appid=intl_category_lib&_schemaid=t_language_def&_appkey=ab0a0e1af1564d78be5cb8d54819df4c&size=1000
Object.defineProperty(exports, "__esModule", { value: true });
exports.findLangNameByCode = exports.findLangCodeByName = exports.LANGUAGES = void 0;
var constants_1 = require("../utils/constants");
exports.LANGUAGES = [
    {
        language_code: 1491922,
        language_abbr: '',
        language_name: '上海话',
    },
    {
        language_code: 1491923,
        language_abbr: '',
        language_name: '不丹语',
    },
    {
        language_code: 1491924,
        language_abbr: '',
        language_name: '东北方言',
    },
    {
        language_code: 1491925,
        language_abbr: '',
        language_name: '丹麦语',
    },
    {
        language_code: 1491926,
        language_abbr: '',
        language_name: '乌尔都语',
    },
    {
        language_code: 1491927,
        language_abbr: '',
        language_name: '伊努伊特语',
    },
    {
        language_code: 1491928,
        language_abbr: '',
        language_name: '伊朗语',
    },
    {
        language_code: 1491929,
        language_abbr: 'ru',
        language_name: '俄语',
    },
    {
        language_code: 1491930,
        language_abbr: '',
        language_name: '保加利亚语',
    },
    {
        language_code: 1491931,
        language_abbr: '',
        language_name: '克罗地亚语',
    },
    {
        language_code: 1491932,
        language_abbr: '',
        language_name: '其他',
    },
    {
        language_code: 1491933,
        language_abbr: '',
        language_name: '冰岛语',
    },
    {
        language_code: 1491934,
        language_abbr: '',
        language_name: '匈牙利语',
    },
    {
        language_code: 1491935,
        language_abbr: '',
        language_name: '北印度语',
    },
    {
        language_code: 1491936,
        language_abbr: '',
        language_name: '南非荷兰语',
    },
    {
        language_code: 1491937,
        language_abbr: 'id',
        language_name: '印尼语',
    },
    {
        language_code: 1491938,
        language_abbr: '',
        language_name: '印度语',
    },
    {
        language_code: 1491939,
        language_abbr: '',
        language_name: '台语',
    },
    {
        language_code: 1491940,
        language_abbr: '',
        language_name: '四川话',
    },
    {
        language_code: 1491941,
        language_abbr: '',
        language_name: '国粤双语',
    },
    {
        language_code: 1491942,
        language_abbr: '',
        language_name: '土耳其语',
    },
    {
        language_code: 1491943,
        language_abbr: '',
        language_name: '塞尔维亚语',
    },
    {
        language_code: 1491944,
        language_abbr: '',
        language_name: '多种语言',
    },
    {
        language_code: 1491945,
        language_abbr: '',
        language_name: '天津话',
    },
    {
        language_code: 1491946,
        language_abbr: '',
        language_name: '孟加拉语',
    },
    {
        language_code: 1491947,
        language_abbr: '',
        language_name: '安徽话',
    },
    {
        language_code: 1491948,
        language_abbr: '',
        language_name: '山西话',
    },
    {
        language_code: 1491949,
        language_abbr: 'he',
        language_name: '希伯来语',
    },
    {
        language_code: 1491950,
        language_abbr: '',
        language_name: '希腊语',
    },
    {
        language_code: 1491951,
        language_abbr: '',
        language_name: '广西话',
    },
    {
        language_code: 1491952,
        language_abbr: 'de',
        language_name: '德语',
    },
    {
        language_code: 1491953,
        language_abbr: 'it',
        language_name: '意大利语',
    },
    {
        language_code: 1491954,
        language_abbr: 'la',
        language_name: '拉丁语',
    },
    {
        language_code: 1491955,
        language_abbr: '',
        language_name: '拉脱维亚语',
    },
    {
        language_code: 1491956,
        language_abbr: '',
        language_name: '挪威语',
    },
    {
        language_code: 1491957,
        language_abbr: '',
        language_name: '捷克语',
    },
    {
        language_code: 1491958,
        language_abbr: '',
        language_name: '斯洛伐克语',
    },
    {
        language_code: 1491959,
        language_abbr: '',
        language_name: '斯洛文尼亚语',
    },
    {
        language_code: 1491960,
        language_abbr: '',
        language_name: '斯瓦希里语',
    },
    {
        language_code: 1491961,
        language_abbr: '',
        language_name: '无声',
    },
    {
        language_code: 8,
        language_abbr: 'ja',
        language_name: '日语',
    },
    {
        language_code: 1491963,
        language_abbr: 'cn',
        language_name: '普通话',
    },
    {
        language_code: 1491964,
        language_abbr: '',
        language_name: '朝鲜语',
    },
    {
        language_code: 1491965,
        language_abbr: '',
        language_name: '柯尔克孜语',
    },
    {
        language_code: 1491966,
        language_abbr: '',
        language_name: '格鲁吉亚语',
    },
    {
        language_code: 1491967,
        language_abbr: '',
        language_name: '比利时语',
    },
    {
        language_code: 1491968,
        language_abbr: '',
        language_name: '河南话',
    },
    {
        language_code: 1491969,
        language_abbr: 'fr',
        language_name: '法语',
    },
    {
        language_code: 1491970,
        language_abbr: '',
        language_name: '波兰语',
    },
    {
        language_code: 1491971,
        language_abbr: 'fa',
        language_name: '波斯语',
    },
    {
        language_code: 1491972,
        language_abbr: '',
        language_name: '泰米尔语',
    },
    {
        language_code: 1491973,
        language_abbr: 'th',
        language_name: '泰语',
    },
    {
        language_code: 1491974,
        language_abbr: '',
        language_name: '温州话',
    },
    {
        language_code: 1491975,
        language_abbr: '',
        language_name: '湖南话',
    },
    {
        language_code: 1491976,
        language_abbr: '',
        language_name: '爱沙尼亚语',
    },
    {
        language_code: 1491977,
        language_abbr: '',
        language_name: '瑞典语',
    },
    {
        language_code: 1491978,
        language_abbr: '',
        language_name: '瑞士语',
    },
    {
        language_code: 1491979,
        language_abbr: '',
        language_name: '甘肃话',
    },
    {
        language_code: 1491980,
        language_abbr: '',
        language_name: '科萨语',
    },
    {
        language_code: 1491981,
        language_abbr: '',
        language_name: '立陶宛语',
    },
    {
        language_code: 1491982,
        language_abbr: '',
        language_name: '粤语',
    },
    {
        language_code: 1491983,
        language_abbr: '',
        language_name: '绍兴话',
    },
    {
        language_code: 1491984,
        language_abbr: '',
        language_name: '维吾尔语',
    },
    {
        language_code: 1491985,
        language_abbr: '',
        language_name: '罗马尼亚语',
    },
    {
        language_code: 1491986,
        language_abbr: '',
        language_name: '老挝语',
    },
    {
        language_code: 1491987,
        language_abbr: '',
        language_name: '芬兰语',
    },
    {
        language_code: 1491988,
        language_abbr: 'en',
        language_name: '英语',
    },
    {
        language_code: 1491989,
        language_abbr: '',
        language_name: '荷兰语',
    },
    {
        language_code: 1491990,
        language_abbr: 'fil',
        language_name: '菲律宾语',
    },
    {
        language_code: 12,
        language_abbr: 'pt',
        language_name: '葡萄牙语',
    },
    {
        language_code: 14,
        language_abbr: 'es',
        language_name: '西班牙语',
    },
    {
        language_code: 1491993,
        language_abbr: '',
        language_name: '贵州方言',
    },
    {
        language_code: 1491994,
        language_abbr: 'vi',
        language_name: '越南语',
    },
    {
        language_code: 1491995,
        language_abbr: '',
        language_name: '车臣语',
    },
    {
        language_code: 1491996,
        language_abbr: '',
        language_name: '重庆话',
    },
    {
        language_code: 1491997,
        language_abbr: '',
        language_name: '闽南语',
    },
    {
        language_code: 1491998,
        language_abbr: '',
        language_name: '阿姆哈拉语',
    },
    {
        language_code: 1491999,
        language_abbr: '',
        language_name: '阿尔巴尼亚语',
    },
    {
        language_code: 54,
        language_abbr: 'ar',
        language_name: '阿拉伯语',
    },
    {
        language_code: 1492001,
        language_abbr: '',
        language_name: '陕西话',
    },
    {
        language_code: 9,
        language_abbr: 'ko',
        language_name: '韩语',
    },
    {
        language_code: 40,
        language_abbr: 'ms',
        language_name: '马来西亚语',
    },
    {
        language_code: 1586331,
        language_abbr: '',
        language_name: '藏语',
    },
    {
        language_code: 1605612,
        language_abbr: '',
        language_name: '小语种',
    },
    {
        language_code: 1657230,
        language_abbr: '',
        language_name: '唐山话',
    },
    {
        language_code: 8229847,
        language_abbr: 'tw',
        language_name: '繁体字',
    },
    {
        language_code: 35,
        language_abbr: 'hi',
        language_name: '印地语',
    },
];
var findLangCodeByName = function (name) {
    var code = constants_1.DEFAULT_LANG.code; // 英语
    exports.LANGUAGES.forEach(function (item) {
        if (item.language_abbr === name) {
            code = item.language_code;
        }
    });
    return code;
};
exports.findLangCodeByName = findLangCodeByName;
var findLangNameByCode = function (code) {
    var name = constants_1.DEFAULT_LANG.name;
    exports.LANGUAGES.forEach(function (item) {
        if (Number(item.language_code) === Number(code)) {
            name = item.language_abbr;
        }
    });
    return name;
};
exports.findLangNameByCode = findLangNameByCode;
